<template>
  <div>
    <div class="columns">
      <div class="column">
        <h1 class="is-size-5 is-uppercase">Storage</h1>
      </div>
      <div class="column has-text-right" v-if="!loading">
        {{ used.toFixed(3) }} GB / {{ total }} GB
        <a @click="active = true">Free</a>
      </div>
    </div>
    <progress
      class="progress is-primary"
      :value="used / total"
      max="1"
      :class="{
        'is-warning': used / total > 0.75,
        'is-danger': used / total > 0.9
      }"
    ></progress>
    <div class="modal" :class="{ 'is-active': active }">
      <div class="modal-background" @click="active = false"></div>
      <div class="modal-body">
        <div class="card" style="width: 700px">
          <div class="card-header">
            <div class="card-header-title">Free Up Space</div>
          </div>
          <div class="card-content">
            <input-field
              label="Clear Attachments Till"
              type="date"
              required=""
              v-model="freeTo"
            ></input-field>
            <p class="has-text-danger has-text-centered">
              This action is irreversible, please ensure you have exported the
              data before proceeding.
            </p>
            <div class="has-text-centered" v-if="processing">
              <button class="button is-dark is-loading"></button>
            </div>
          </div>
          <div class="card-footer" v-if="!processing">
            <a class="card-footer-item" @click="active = false">Cancel</a>
            <a class="card-footer-item has-text-danger" @click="free">Delete</a>
          </div>
        </div>
      </div>
      <div class="modal-close is-large" @click="active = false"></div>
    </div>
    <div class="toast" :class="{ 'is-active': isToastVisible }">
      Attachments cleared successfully
    </div>
  </div>
</template>
<script>
import http from "../../../http";
export default {
  data() {
    return {
      active: false,
      used: 0,
      total: 0,
      loading: true,
      processing: false,
      freeTo: "",
      isToastVisible: false
    };
  },
  methods: {
    fetch() {
      let component = this;
      component.loading = true;
      http
        .get("/stats/storage")
        .then(response => {
          component.loading = false;
          component.used = response.data.used;
          component.total = response.data.total;
        })
        .catch(error => {
          component.loading = false;
          console.error(error);
        });
    },
    free() {
      let component = this;
      component.processing = true;
      http
        .post("/stats/storage/free", { date: component.freeTo })
        .then(response => {
          component.processing = false;
          component.active = false;
          component.isToastVisible = true;
          setTimeout(() => {
            component.isToastVisible = false;
          }, 5000);
        });
    }
  },
  watch: {
    active() {
      this.freeTo = "";
    }
  },
  mounted() {
    this.fetch();
  }
};
</script>
